/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { Alarm } from '../models/alarm';
import { DescriptiveAlarm } from '../models/descriptive-alarm';
@Injectable({
  providedIn: 'root',
})
class EucsAlarmService extends __BaseService {
  static readonly EucsAlarmAcknowledgePath = '/api/eucs/EucsAlarm/Acknowledge/{customerId}/{id}';
  static readonly EucsAlarmGetActiveAlarmsPath = '/api/eucs/EucsAlarm/GetActiveAlarms/{customerId}';
  static readonly EucsAlarmGetDescriptiveActiveAlarmsPath = '/api/eucs/EucsAlarm/GetDescriptiveActiveAlarms/{customerId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `EucsAlarmService.EucsAlarmAcknowledgeParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   *
   * @return  or
   */
  EucsAlarmAcknowledgeResponse(params: EucsAlarmService.EucsAlarmAcknowledgeParams): __Observable<__StrictHttpResponse<Alarm | Alarm>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;


    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/eucs/EucsAlarm/Acknowledge/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.id))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Alarm | Alarm>;
      })
    );
  }
  /**
   * @param params The `EucsAlarmService.EucsAlarmAcknowledgeParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `customerId`:
   *
   * @return  or
   */
  EucsAlarmAcknowledge(params: EucsAlarmService.EucsAlarmAcknowledgeParams): __Observable<Alarm | Alarm> {
    return this.EucsAlarmAcknowledgeResponse(params).pipe(
      __map(_r => _r.body as Alarm | Alarm)
    );
  }

  /**
   * @param customerId undefined
   */
  EucsAlarmGetActiveAlarmsResponse(customerId: number): __Observable<__StrictHttpResponse<Array<Alarm>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsAlarm/GetActiveAlarms/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Alarm>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  EucsAlarmGetActiveAlarms(customerId: number): __Observable<Array<Alarm>> {
    return this.EucsAlarmGetActiveAlarmsResponse(customerId).pipe(
      __map(_r => _r.body as Array<Alarm>)
    );
  }

  /**
   * @param customerId undefined
   */
  EucsAlarmGetDescriptiveActiveAlarmsResponse(customerId: number): __Observable<__StrictHttpResponse<Array<DescriptiveAlarm>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/eucs/EucsAlarm/GetDescriptiveActiveAlarms/${encodeURIComponent(String(customerId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DescriptiveAlarm>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  EucsAlarmGetDescriptiveActiveAlarms(customerId: number): __Observable<Array<DescriptiveAlarm>> {
    return this.EucsAlarmGetDescriptiveActiveAlarmsResponse(customerId).pipe(
      __map(_r => _r.body as Array<DescriptiveAlarm>)
    );
  }
}

module EucsAlarmService {

  /**
   * Parameters for EucsAlarmAcknowledge
   */
  export interface EucsAlarmAcknowledgeParams {
    id: number;
    customerId: number;
  }
}

export { EucsAlarmService }
